export const ROUTES = {
	PROJECT_VIEW: '/',
	SETTINGS: '/settings',
	/** Dev only: frontend structure & component wiki. Not available in production. */
	WIKI: '/wiki',
	DATA_CATALOG: '/data-catalog',
	DATA_CATALOG_TABLE: '/data-catalog/:tableId',
	REPORTS: '/reports',
	REPORTS_REPORT: '/reports/:reportId',
	ONTOLOGY: '/ontology',
	BRANCHES: '/branches',
	BRANCHES_BRANCH: '/branches/*',
	MERGE_REQUESTS: '/merge-requests',
	MERGE_REQUESTS_MR: '/merge-requests/:mrId',
	RELEASES: '/releases',
	RELEASES_RELEASE: '/releases/:releaseId',
	DEPLOYMENT_DASHBOARD: '/deployment-dashboard',
	DEPLOYMENT_PACKAGES: '/deployment-packages',
	DEPLOYMENT_PACKAGES_PACKAGE: '/deployment-packages/:packageId',
	SYSTEM_SETTINGS: '/system-settings',
	AI_AGENTS: '/ai-agents',
} as const
